export default "__VITE_ASSET__61bfcbc4__"